import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@gasbuddy/react-components';
import { getFuelBrand, getCstoreBrand } from '../../../lib/utils/station';
import { DEFAULT_STATION_LOGO } from '../../constants';
import styles from './StationBrandings.module.css';
import getOptimizedImageUrl from '../../../lib/utils/getOptimizedImageUrl';

// Logo images need to be sized 33xauto
const getOptimizedImage = url => getOptimizedImageUrl(url, 33);

const StationBrandings = ({
  brands,
  stationName,
  containerClass,
}) => {
  // default to unbranded station
  let brandingMarkup = (
    <div className={containerClass}>
      <Image
        src={getOptimizedImage(DEFAULT_STATION_LOGO)}
        alt={stationName}
      />
    </div>
  );

  const [firstBrand, secondBrand] = brands.length === 2 ? brands : [null, null];
  const isSingleBranded = firstBrand && secondBrand && firstBrand.brand_id === secondBrand.brand_id;

  // overwrite brand markup if station has brandings set
  if (brands.length === 1 || isSingleBranded) {
    // station is single-branded
    brandingMarkup = (
      <div className={containerClass}>
        <Image
          src={getOptimizedImage(brands[0].image_url || DEFAULT_STATION_LOGO)}
          alt={isSingleBranded && firstBrand.name ? firstBrand.name : stationName}
        />
      </div>
    );
  } else if (brands.length === 2) {
    // station is dual-branded
    const fuelBrand = getFuelBrand(brands);
    const cstoreBrand = getCstoreBrand(brands);
    brandingMarkup = (
      <React.Fragment>
        <div className={containerClass}>
          <Image
            src={getOptimizedImage((fuelBrand || {}).image_url || DEFAULT_STATION_LOGO)}
            alt={(fuelBrand || {}).name || stationName}
          />
        </div>
        <div className={containerClass}>
          <Image
            src={getOptimizedImage((cstoreBrand || {}).image_url || DEFAULT_STATION_LOGO)}
            alt={(cstoreBrand || {}).name || stationName}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className={styles.logoImages}>
      {brandingMarkup}
    </div>
  );
};

StationBrandings.propTypes = {
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      image_url: PropTypes.string,
    }),
  ),
  stationName: PropTypes.string.isRequired,
  containerClass: PropTypes.string.isRequired,
};

StationBrandings.defaultProps = {
  brands: [],
};

export default StationBrandings;
